export default "__VITE_PUBLIC_ASSET__99090a58__"